import { combineReducers } from 'redux';
import roleReducer from './Role/reducer';


const rootReducer = combineReducers({
    roleReducer, 
  
});

export default rootReducer;